import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { CallBoardsDashboardService } from './call-boards-dashboard.service';
import { Observable, timer, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { tap, map, switchMap } from 'rxjs/operators';
import { AppCookieService } from 'src/app/app-cookie.service';

@Component({
  selector: 'app-call-board-dashboard',
  templateUrl: './call-board-dashboard.component.html',
  styleUrls: ['./call-board-dashboard.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class CallBoardDashboardComponent implements OnInit, OnDestroy {

  boardLocation: string;
  playFlag: boolean = false;
  timerFrequency: number = 10000;
  $timerDanger: Subscription;
  $timerPageLoaded: Subscription;
  currentView: string;
  soundOn: boolean;
  errorMessage: string;
  showErrorBox: boolean;

  soundDanger: any;
  testSound: any; 

  constructor(private data: CallBoardsDashboardService, private route: ActivatedRoute, private cookieService: AppCookieService) {
    try {
      this.errorMessage = "";
      this.soundDanger = new Audio("./sounds/sound-danger.mp3");
      this.testSound = new Audio("./sounds/sound-danger.mp3");
      this.showErrorBox = false;
      // save current view
      this.currentView = this.route.snapshot.paramMap.get('view');
    }
    catch (err) {
      this.setError("constructor() -> " + err.message);
    }
  }

  viewState$: Observable<any>;

  ngOnInit() {
    this.viewState$ = timer(0, 2000).pipe(
      map(() => {
        this.route.snapshot.paramMap.get('view') != this.currentView ? this.soundDanger.pause() : null,
          this.currentView = this.route.snapshot.paramMap.get('view');
      }),
      switchMap(() => this.data.getCallBoardData(
        this.route.snapshot.paramMap.get('view'),
        this.route.snapshot.paramMap.get('boardLocation'))
      ),
      tap(d => {
        this.playSound(d["playAlert"])
      })
    );

    // start timer to see if eliments are loaded
    try {
      if (window.innerWidth > 600) {
        const t = timer(0, 10);
        this.$timerPageLoaded = t.subscribe(t => { this.isPageLoaded(); });
      }
    }
    catch (err) {
      this.setError("ngOnInit() -> " + err.message);
    }
  }

  onResize(event: any) {
    try {
      if (event.target.innerWidth < 600) {
        if (this.soundDanger && !this.soundDanger.paused)
          this.soundDanger.pause();
        this.playFlag = false;
        this.stopTimer();
        return;
      }
      this.playSound(this.playFlag);
    }
    catch (err) {
      this.setError("onResize() -> " + err.message);
    }
  }

  isPageLoaded() {

    try {
      if (document.getElementById("soundTrigerIcon")) {
        this.soundOn = (this.cookieService.get("soundOn") === "true");
        this.setSoundTrigerIcon();
        if (this.$timerPageLoaded && this.$timerPageLoaded.closed === false)
          this.$timerPageLoaded.unsubscribe();
      }
    }
    catch (err) {
      this.setError("isPageLoaded() -> " + err.message);
    }
  }

  ngOnDestroy() {
    try {
      if (this.soundDanger && !this.soundDanger.paused)
        this.soundDanger.pause();
      this.stopTimer();
      if (this.$timerPageLoaded && this.$timerPageLoaded.closed === false)
        this.$timerPageLoaded.unsubscribe();
    }
    catch (err) {
      this.setError("ngOnDestroy() -> " + err.message);
    }
  }

  showHeader() {
    try {
      var x = document.getElementById("pageheader");
      x.style.display = x.style.display === "none" ? "block" : "none";

      document.getElementById("headTriger")
        .style.top = x.style.display === "none" ? "10px" : "60px";
      document.getElementById("headTrigerIcon")
        .className = x.style.display === "none" ? "fa fa-arrow-down" : "fa fa-arrow-up";
    }
    catch (err) {
      this.setError("showHeader() -> " + err.message);
    }
  }

  // sound funcs
  playSound(isAlert: boolean) {
    try {
      this.playFlag = window.innerWidth <= 600 ? false : isAlert;
      if (window.innerWidth <= 600) {
        if (this.soundDanger.paused === false)
          this.soundDanger.pause();
        return;
      }
      this.soundOn ? this.startTimer() : this.stopTimer();
      if (!this.soundOn && this.soundDanger && !this.soundDanger.paused)
        this.soundDanger.pause();
      this.setSoundTrigerIcon();
    }
    catch (err) {
      this.setError("playSound() -> " + err.message);
    }
  }
  // calling on image click
  soundTriger() {
    try {
      this.soundOn = this.soundOn ? false : true;
      this.cookieService.set("soundOn", this.soundOn.toString(), new Date(new Date().setFullYear(new Date().getFullYear() + 10)));
      this.setSoundTrigerIcon();
      this.playSound(this.playFlag);
    }
    catch (err) {
      this.setError("soundTriger() -> " + err.message);
    }
  }

  setSoundTrigerIcon() {
    try {
      var s = document.getElementById("soundTrigerIcon");
      if (s && s.className) {
        if (this.soundOn && s.className !== "fa fa-volume-up")
          s.className = "fa fa-volume-up";
        else if (!this.soundOn && s.className !== "fa fa-volume-off")
          s.className = "fa fa-volume-off";
      }
    }
    catch (err) {
      this.setError("setSoundTrigerIcon() -> " + err.message);
    }
  }

  playDangerSound() {
    try {
      if (window.innerWidth <= 600) {
        this.soundDanger.pause();
        return;
      }
      if (this.playFlag === true) {
        if (this.soundDanger.paused === true) {
          this.soundDanger.currentTime = 0;
          this.soundDanger.play();
        }
      }
      else {
        this.soundDanger.pause();
      }
    }
    catch (err) {
      this.setError("playDangerSound() -> " + err.message);
    }
  }

  startTimer() {
    try {
      if (window.innerWidth <= 600 || (this.$timerDanger && this.$timerDanger.closed === false))
        return;
      const t = timer(0, this.timerFrequency);
      this.$timerDanger = t.subscribe(t => { this.playDangerSound(); });
    }
    catch (err) {
      this.setError("startTimer() -> " + err.message);
    }
  }
  stopTimer() {
    try {
      if (this.$timerDanger && this.$timerDanger.closed === false) {
        this.$timerDanger.unsubscribe();
      }
    }
    catch (err) {
      this.setError("stopTimer() -> " + err.message);
    }
  }
  // end sound funcs

  setError(err: string) {
    this.errorMessage = err;
    console.log(err);
  }

  boardNameClick() {
    if (this.soundDanger && !this.soundDanger.paused)
      this.testSound.pause();
    else
      this.testSound.play();
  }

  errorBoxTriger() {
    this.showErrorBox = this.showErrorBox ? false : true;
  }
}
